import messages from "./messages.json";

export const localesMessages = {
  en: messages.en,
  fr: messages.fr,
};
